export default "__VITE_ASSET__3I9jqLfu__"